import Common from '../../Common';
import { FileType } from '../../Enums';
import Argument from './report/Argument';
import Type from './report/Type';

export interface UpdateBody {
	interval: string
	active: boolean
	name?: string
	description?: string
}

export interface CreateBody extends Partial<UpdateBody> {
	report_type_id: id
	arguments: any
}

export interface DownloadBody {
	report_type_id: id,
	interval: string,
	arguments: Array<{
		key: string
		value: string
	}>,
	date_from: string,
	date_to: string,
}

export interface SendBody {
	dateFrom?: string,
	dateTo?: string
}

const Report = class extends Common {
	type: InstanceType<typeof Type>;
	argument: InstanceType<typeof Argument>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.type = new Type(headers);
		this.argument = new Argument(headers);
	}

	async browse(companyId: id, search: any) {
		return this.get(`/company/${companyId}/report`, search);
	}

	async browseByReportTypeId(companyId: id, reportTypeId: id) {
		return this.get(`/company/${companyId}/report/${reportTypeId}`);
	}

	async read(companyId: id, reportId: id) {
		return this.get(`/company/${companyId}/report/read/${reportId}`);
	}

	async create(companyId: id, body: CreateBody) {
		return this.post(`/company/${companyId}/report`, body);
	}

	async update(companyId: id, reportId: id, body: UpdateBody) {
		return this.patch(`/company/${companyId}/report/${reportId}`, body);
	}

	// @ts-expect-error please i just want to build this project
	async downloadNotSaved(companyId: id, fileType: FileType, body: DownloadBody): CustomResponse<Blob> {
		return this.post(`/company/${companyId}/report/download/${fileType}`, body, { responseType: 'blob' });
	}

	// @ts-expect-error please i just want to build this project
	async download(companyId: id, reportId: id, fileType: FileType = FileType.xlsx): CustomResponse<Blob> {
		return this.get(`/company/${companyId}/report/${reportId}/download/${fileType}`, {}, { responseType: 'blob' });
	}

	async send(companyId: id, reportId: id, interval?: SendBody) {
		return this.get(`/company/${companyId}/report/${reportId}/send`, interval);
	}

	async delete(companyId: id, reportId: id) {
		return this.doDelete(`/company/${companyId}/report/${reportId}`);
	}
}

export default Report;
